import { useState } from 'react';
import { Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

import Tooltip from '@/v2/components/Tooltip/Tooltip';

import Input from '../Input';
import { Container } from './GeneratePassword.styled';
import { studentPasswords } from '@/modules/constants/Passwords';

export default function GeneratePassword({ value = '', onChange, ...props }) {
  const [passwordValue, setPasswordValue] = useState(value);

  return (
    <Container>
      <Input
        label="Password"
        autoComplete="off"
        value={passwordValue}
        onChange={(e) => {
          setPasswordValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={props.placeholder || ''}
        {...props}
      />
      <Tooltip title="Click to generate an easy to remember password">
        <Button
          type="link"
          onClick={() => {
            const newPassword = generateNewPassword();
            setPasswordValue(newPassword);
            onChange(newPassword);
          }}
        >
          <ReloadOutlined style={{ fontSize: 20, width: 10 }} />
        </Button>
      </Tooltip>
    </Container>
  );
}

function generateNewPassword() {
  const index = Math.floor(Math.random() * studentPasswords.length);
  return studentPasswords[index];
}
